export default __webpack_public_path__ + "static/IN-9008v5905_resTestBig3-dac0fb563c12f72cdee7da7537f9b950.webp";